<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-4 picture">
            </div>
            <div class="col-8 text">
                <div class="row h-100 ml-30">
                    <div class="col-sm-12 my-auto">
                        <h1>DIRK DEVOS</h1>
                        <h2>Leads</h2>
                        <h2>Teaches</h2>
                        <h2>Guides</h2>
                        <p>Leading transformational change<br />
                            Evolve ownership and responsibility<br />
                            Guides senior leaders and teams to achieve impact</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid centeredtext">
        <div class="row">
            <div class="container">
                <div class="row">
                    <div class="col-md">
                        Dirk is an international expert in leading transformational change with a particular emphasis on systemic interventions through leadership guidance. Dirk works with global clients in a range of different industries, among others: Financial Services, FMCG, Professional Service Firms, Retail, Process Industry, Telecom, Large Family Business, ...
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md textleft">
                <p>His interventions are minimalistic and strive to evolve ownership and responsibility from the first moment onwards. He is strong in helping senior leaders build trust amongst each other and throughout the organisation, while at the same time building a high performing climate of challenge and drive for execution.
                    Dirk guides senior leaders and their teams to achieve robust strategic impact. His core area of expertise includes personal and team guidance, an integrated approach of strategy and leadership, high impact execution power, intercultural cooperation and strategic breakthrough innovation. He focuses on helping leaders to shift the core of the organisational DNA towards sustainable high performance.</p>
            </div>
            <div class="col-md textright">
                <p>Previously Dirk was a partner at several global leadership boutique firms. He is a graduate of the MIT/Dialogos Strategic Dialogue Master’s programme. He is co-author of ‘Leading from behind’ focusing on building interpersonal trust and collective glue. He is also co-author of ‘21 Leaders for the 21st Century’, elaborating on core values and win-win dilemma strategies in an intercultural and ambiguous business context.<br />
                    Over time he has developed deeply rooted, integrated and validated practice capabilities in many different roles amongst others board room advisor, executive coach, strategy consultant, OD consultant, change process and workshop designer and facilitator, team coach, trainer, train-the-trainer, consultant’s consultant, guide for high impact learning journeys, dialogue facilitator and trusted guide for personal development work. <a href="https://www.courage11.com/">courage11.com</a></p>
            </div>
        </div>
    </div>
    <div class="container-fluid position-relative">
        <div class="row">
            <div class="container">
                <div class="row">
                    <footer class="col-md text-center">
                        FreshOrange BV - Hollander 7 - NL 6093 PC Heythuysen - the Netherlands +316 22 565 138<br />
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(0);
    }
}

@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(0);
    }
}

@keyframes fadein {
    0% {
        opacity: 0;
    }

    40% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes slidedown {
    0% {
        height: 0;
    }

    100% {
        height: auto;
    }
}

@keyframes zoom-in-zoom-out {
    0% {
        transform: scale(0, 0);
    }

    40% {
        transform: scale(0, 0);
    }

    100% {
        transform: scale(1, 1);
    }
}

@keyframes slide-in-from-bottom {
    0% {
        opacity: 0;
        margin-top: 100px;
    }

    60% {
        opacity: 0;
        margin-top: 100px;
    }

    100% {
        opacity: 1;
        margin-top: 0px;
    }
}

.textleft {
    padding: 30px;
    animation: 1s ease-out 0s 1 zoom-in-zoom-out;
}

.textright {
    padding: 30px;
    animation: 1.5s ease-out 0s 1 zoom-in-zoom-out;
}

.fadein {
    animation: 1s ease-out 0s 1 slidedown;
}

body.loaded .fadein {
    opacity: 1;
}

.picture {
    background-image: url("@/assets/images/dirk.jpg");
    background-size: cover;
    background-position: top center;
    min-height: 30vh;
    animation: 0.7s ease-in-out 0s 1 slideInFromLeft;
}

.text {
    background-color: #e58d4c; /*#db5d00;*/
    color: white;
    text-align: left;
    animation: 1s ease-in-out 0s 1 fadein;
}

.text h1 {
    margin-top: 20px;
    font-size: 1rem;
    color: #692c00;
    margin-bottom: 10px;
}

.text h2 {
    margin: 0px;
    padding: 0px;
    font-weight: bold;
    font-size: 3rem;
    line-height: 1.1 !important;

}

.text p {
    margin-top: 20px;
}

.centeredtext {
    background: #ffd8ac; /*#ffc789;*/
    padding: 20px;
    animation: 1s ease-in-out 0s 1 fadein;
}

a {
    color: #db5d00;
    text-decoration: none;
}

a:hover {
    border-bottom: 1px solid #db5d00;
}

footer {
    position: absolute;
    animation: 1.5s ease-in-out 0s 1 slide-in-from-bottom;
    background-color: #AAA;
    padding: 10px;
}

.ml-30 {
    margin-left: 30px
}

@media (max-width: 767px) {

    h1 {
        margin-top: 20px;
        font-size: 1.2rem !important;
    }
    .textleft {
      padding: 30px 30px 10px 30px;
        
    }

.textright {
    padding: 0 30px;
    
}
}
</style>